function updateStickyAtcPriceElements(context, variant, quantity = 1) {
  if (!context || !variant) return;

  const safeQuantity = Math.max(Number.parseInt(quantity, 10) || 1, 1);
  const totalPrice = variant.price * safeQuantity;
  const totalCompareAtPrice = variant.compare_at_price ? variant.compare_at_price * safeQuantity : null;
  const moneyFormat = FoxTheme.settings.moneyFormat;

  context.querySelectorAll('.f-price').forEach((priceWrapper) => {
    const salePrice = priceWrapper.querySelector('.f-price-item--sale');
    const regularPrices = priceWrapper.querySelectorAll('.f-price-item--regular');
    const saleValue = priceWrapper.querySelector('[data-sale-value]');
    const unitPriceWrapper = priceWrapper.querySelector('.f-price__unit-wrapper');
    const unitPrice = unitPriceWrapper?.querySelector('.f-price__unit');
    const isOnSale = totalCompareAtPrice && totalCompareAtPrice > totalPrice;

    priceWrapper.classList.toggle('f-price--on-sale', Boolean(isOnSale));
    priceWrapper.classList.toggle('f-price--sold-out', !variant.available);

    if (salePrice) salePrice.innerHTML = FoxTheme.Currency.formatMoney(totalPrice, moneyFormat);

    regularPrices.forEach((item) => {
      item.innerHTML = isOnSale
        ? `<s>${FoxTheme.Currency.formatMoney(totalCompareAtPrice, moneyFormat)}</s>`
        : FoxTheme.Currency.formatMoney(totalPrice, moneyFormat);
    });

    if (saleValue && isOnSale) {
      saleValue.textContent = `${Math.round(((totalCompareAtPrice - totalPrice) * 100) / totalCompareAtPrice)}%`;
    }

    if (variant.unit_price_measurement && unitPrice) {
      const measurement = variant.unit_price_measurement;
      const baseUnit = `${measurement.reference_value !== 1 ? measurement.reference_value : ''}${measurement.reference_unit}`;
      unitPriceWrapper.classList.remove('hidden');
      unitPrice.innerHTML = `<span>${FoxTheme.Currency.formatMoney(
        variant.unit_price,
        moneyFormat
      )}</span>/<span data-unit-price-base-unit>${baseUnit}</span>`;
    } else {
      unitPriceWrapper?.classList.add('hidden');
    }
  });
}

function syncFallbackStickyAtcVariantSelect(select) {
  const stickyAtc = select.closest('sticky-atc-bar');
  const container = stickyAtc?.closest('.sticky-atc-bar');
  const productInfo = stickyAtc?.dataset.productRootId
    ? document.getElementById(stickyAtc.dataset.productRootId)
    : stickyAtc?.closest('product-info');
  const mainVariantSelects = productInfo?.querySelector('variant-selects');
  const variantDataElement = container?.querySelector('[type="application/json"]');

  if (!stickyAtc || !productInfo || !mainVariantSelects || !variantDataElement) return;

  const variant = JSON.parse(variantDataElement.textContent).find((item) => item.id === Number(select.value));
  if (!variant) return;

  // Optimistic UI update on sticky ATC bar before server fetch completes
  if (stickyAtc && typeof stickyAtc.updateTotalPrices === 'function') {
    stickyAtc.currentVariant = variant;
    stickyAtc.updateTotalPrices();
    stickyAtc.updateSubtitle?.(variant);
    const currentBtn = stickyAtc.querySelector(".sticky-atc-bar__form [name='add']");
    const hasWaitlistConfig =
      currentBtn?.hasAttribute("data-waitlist-popup-link") ||
      currentBtn?.getAttribute("data-waitlist-trigger") === "true";
    const isWaitlist = !variant.available && hasWaitlistConfig;
    const waitlistAttributes = window.ArzopaWaitlist?.extractAttributes(currentBtn, {
      variantId: variant.id,
      variantTitle: variant.title,
    }) || {};

    if (isWaitlist) {
      stickyAtc.updateButton(false, waitlistAttributes.waitlistText, true, true, waitlistAttributes);
    } else if (!variant.available) {
      stickyAtc.updateButton(true, FoxTheme.variantStrings.soldOut, true, false);
    } else {
      stickyAtc.updateButton(false, FoxTheme.variantStrings.addToCart, true, false);
    }
  }

  let eventTarget;
  Array.from(mainVariantSelects.querySelectorAll('select, fieldset'), (element, index) => {
    const optionValue = variant.options[index];
    if (optionValue === undefined) return;

    if (element.tagName === 'SELECT') {
      const selectedOption = Array.from(element.options).find((option) => option.value === optionValue);
      if (!selectedOption) return;

      element.value = optionValue;
      Array.from(element.options).forEach((option) => option.toggleAttribute('selected', option === selectedOption));
      eventTarget = element;
      return;
    }

    const selectedInput = Array.from(element.querySelectorAll('input[type="radio"]')).find(
      (input) => input.value === optionValue
    );
    if (selectedInput) {
      selectedInput.checked = true;
      eventTarget = selectedInput;
    }
  });

  if (!eventTarget) return;

  const target = eventTarget.tagName === 'SELECT' ? eventTarget.selectedOptions[0] : eventTarget;
  const eventData = {
    data: {
      event: {
        target: eventTarget,
        detail: { source: 'sticky-atc-bar' },
      },
      target,
      selectedOptionValues: Array.from(
        mainVariantSelects.querySelectorAll('select option[selected], fieldset input:checked')
      ).map(({ dataset }) => dataset.optionValueId),
    },
  };

  if (typeof productInfo.handleOptionValueChange === 'function') {
    productInfo.handleOptionValueChange(eventData);
  } else {
    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, eventData);
  }
}

document.addEventListener(
  'change',
  (event) => {
    const select = event.target.closest?.('.sticky-atc-bar__variant-select');
    if (select) syncFallbackStickyAtcVariantSelect(select);
  },
  true
);

window.FoxTheme?.pubsub?.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
  const { sectionId, variant } = event?.data || {};
  if (!variant) return;

  document.querySelectorAll('sticky-atc-bar').forEach((stickyAtc) => {
    const productInfo = stickyAtc.dataset.productRootId
      ? document.getElementById(stickyAtc.dataset.productRootId)
      : stickyAtc.closest('product-info');
    if (productInfo?.dataset.section !== sectionId) return;

    const select = stickyAtc.querySelector('.sticky-atc-bar__variant-select');
    if (!select) return;

    select.value = variant.id;
    Array.from(select.options).forEach((option) => option.toggleAttribute('selected', option.value === select.value));
  });
});

if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        this.handleMediaChange = this.checkDevice.bind(this);
        this.handleVariantChange = this.handleVariantChange.bind(this);
        this.handleMainQuantityChange = this.handleMainQuantityChange.bind(this);
        this.handleStickyQuantityChange = this.handleStickyQuantityChange.bind(this);
        document.body.classList.add('sticky-atc-bar-enabled');
      }

      get variantIdSelect() {
        return this.querySelector('[name="id"]');
      }

      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.productRoot = this.dataset.productRootId
          ? document.getElementById(this.dataset.productRootId)
          : this.closest('product-info');
        this.productFormActions = this.productRoot?.querySelector('.main-product-form');
        this.mainProductInfo = this.productRoot;
        this.container = this.closest('.sticky-atc-bar');

        this.variantData = this.getVariantData();
        this.currentVariant = this.getCurrentVariant();

        this.syncQuantityInputs();
        this.updateTotalPrices();
        this.syncWithMainProductForm();
        this.init();
      }

      disconnectedCallback() {
        this.mediaQuery?.removeEventListener('change', this.handleMediaChange);
        this.mainQuantityInput?.removeEventListener('change', this.handleMainQuantityChange);
        this.stickyQuantityInput?.removeEventListener('change', this.handleStickyQuantityChange);
        this.observer?.disconnect();
        this.variantChangeUnsubscriber?.();
        if (this.updateVariantTimeout) clearTimeout(this.updateVariantTimeout);

        if (!document.querySelector('sticky-atc-bar')) {
          document.body.classList.remove('sticky-atc-bar-enabled');
        }

        this.initialized = false;
      }

      getVariantData() {
        this.variantData =
          this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      getCurrentVariant() {
        const variantId = Number(this.variantIdSelect?.value);
        return this.variantData.find((variant) => variant.id === variantId) || this.variantData[0];
      }

      syncQuantityInputs() {
        this.mainQuantityInput = this.productRoot?.querySelector(
          '.product-form__quantity quantity-input .quantity__input'
        );
        this.stickyQuantityInput = this.querySelector('quantity-input .quantity__input');

        if (!this.mainQuantityInput || !this.stickyQuantityInput) return;

        // Keep both product quantity controls aligned without affecting cart or recommendation forms.
        this.updateQuantityInput(this.stickyQuantityInput, this.mainQuantityInput.value);
        this.mainQuantityInput.addEventListener('change', this.handleMainQuantityChange);
        this.stickyQuantityInput.addEventListener('change', this.handleStickyQuantityChange);
      }

      handleMainQuantityChange() {
        if (this.isSyncingQuantity) return;
        this.updateQuantityInput(this.stickyQuantityInput, this.mainQuantityInput.value);
        this.updateTotalPrices();
      }

      handleStickyQuantityChange() {
        if (this.isSyncingQuantity) return;
        this.updateQuantityInput(this.mainQuantityInput, this.stickyQuantityInput.value);
        this.updateTotalPrices();
      }

      updateQuantityInput(input, value) {
        if (!input || input.value === value) return;

        this.isSyncingQuantity = true;
        try {
          input.value = value;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        } finally {
          this.isSyncingQuantity = false;
        }
      }

      updateTotalPrices() {
        if (!this.currentVariant) return;

        const quantity = this.mainQuantityInput?.value || this.stickyQuantityInput?.value || 1;
        this.updatePrice(this, quantity);
      }

      init() {
        if (!this.productFormActions) {
          this.container.classList.add('sticky-atc-bar--show');
          return;
        }
        this.productId = this.dataset.productId;

        this.mediaQuery = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        this.mediaQuery.addEventListener('change', this.handleMediaChange);
        this.checkDevice();

        const rootMargin = `${this.productFormActions.offsetHeight}px 0px 0px 0px`;
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const isShown = !entry.isIntersecting;
              this.container.classList.toggle('sticky-atc-bar--show', isShown);
              document.documentElement.style.setProperty(
                '--sticky-atc-bar-height',
                isShown ? `${this.clientHeight}px` : '0px'
              );
            });
          },
          { threshold: 1, rootMargin }
        );
        this.observer.observe(this.productFormActions);
      }

      checkDevice() {
        document.documentElement.style.setProperty(
          '--sticky-atc-bar-height',
          this.container?.classList.contains('sticky-atc-bar--show') ? `${this.clientHeight}px` : '0px'
        );
      }

      updateButton(disable = true, text, modifyClass = true, isWaitlist = false, waitlistAttributes = {}) {
        const productForm = this.querySelector('.sticky-atc-bar__form');
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        const dynamicCheckout = productForm.querySelector('.product-form__button-dynamic');
        if (!addButton) return;

        const addButtonText = addButton.querySelector('.btn__text') || addButton.querySelector('span');

        if (isWaitlist) {
          addButton.removeAttribute('disabled');
          addButton.setAttribute('type', 'button');
          addButton.setAttribute('data-waitlist-trigger', 'true');
          addButton.classList.add('btn--waitlist');

          if (waitlistAttributes.popupLink) {
            addButton.setAttribute('data-waitlist-popup-link', waitlistAttributes.popupLink);
          }
          if (waitlistAttributes.triggerSelector) {
            addButton.setAttribute('data-trigger-selector', waitlistAttributes.triggerSelector);
          }
          if (waitlistAttributes.modalId) {
            addButton.setAttribute('data-modal-id', waitlistAttributes.modalId);
          }
          if (waitlistAttributes.customJs) {
            addButton.setAttribute('data-custom-js', waitlistAttributes.customJs);
          }
          if (waitlistAttributes.variantId) {
            addButton.setAttribute('data-variant-id', waitlistAttributes.variantId);
          }
          if (waitlistAttributes.variantTitle) {
            addButton.setAttribute('data-variant-title', waitlistAttributes.variantTitle);
          }
          if (waitlistAttributes.productId) {
            addButton.setAttribute('data-product-id', waitlistAttributes.productId);
          }
          if (waitlistAttributes.productTitle) {
            addButton.setAttribute('data-product-title', waitlistAttributes.productTitle);
          }

          if (addButtonText) {
            addButtonText.textContent =
              text || waitlistAttributes.waitlistText || FoxTheme.variantStrings.joinWaitlist || 'JOIN THE WAITLIST';
          }
          if (dynamicCheckout) dynamicCheckout.classList.add('hidden');
        } else if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          addButton.setAttribute('type', 'submit');
          addButton.removeAttribute('data-waitlist-trigger');
          addButton.removeAttribute('data-waitlist-popup-link');
          addButton.removeAttribute('data-trigger-selector');
          addButton.removeAttribute('data-modal-id');
          addButton.removeAttribute('data-custom-js');
          addButton.classList.remove('btn--waitlist');
          if (text && addButtonText) addButtonText.textContent = text;
          if (dynamicCheckout) dynamicCheckout.classList.add('hidden');
        } else {
          addButton.removeAttribute('disabled');
          addButton.setAttribute('type', 'submit');
          addButton.removeAttribute('data-waitlist-trigger');
          addButton.removeAttribute('data-waitlist-popup-link');
          addButton.removeAttribute('data-trigger-selector');
          addButton.removeAttribute('data-modal-id');
          addButton.removeAttribute('data-custom-js');
          addButton.classList.remove('btn--waitlist');
          if (addButtonText) addButtonText.textContent = FoxTheme.variantStrings.addToCart;
          if (dynamicCheckout) dynamicCheckout.classList.remove('hidden');
        }
      }

      updatePrice(context = this, quantity = 1) {
        updateStickyAtcPriceElements(context, this.currentVariant, quantity);
      }

      updateSubtitle(variant) {
        if (!this.querySelector('.sticky-atc-bar__product-subtitle--out-of-stock')) return;
        this.classList.toggle('sticky-atc-bar--sold-out', !variant?.available);
      }

      syncWithMainProductForm() {
        this.variantChangeUnsubscriber = FoxTheme.pubsub.subscribe(
          FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
          this.handleVariantChange
        );
      }

      handleVariantChange(event) {
        const isMainProduct = event?.data?.sectionId === this.mainProductInfo?.dataset.section;
        if (!isMainProduct) return;
        const variant = event.data.variant;
        const html = event.data.html;
        const variantInput = this.variantIdSelect;

        this.currentVariant = variant;
        this.updateSubtitle(variant);
        if (variantInput) {
          variantInput.value = variant?.id ?? '';
          Array.from(variantInput.options || []).forEach((option) => {
            option.toggleAttribute('selected', option.value === variantInput.value);
          });
        }
        if (variant) this.updateTotalPrices();

        const sectionId = this.mainProductInfo?.dataset.section;
        const mainSubmitBtn =
          html?.getElementById?.(`ProductSubmitButton-${sectionId}`) ||
          document.getElementById(`ProductSubmitButton-${sectionId}`);

        const currentBtn = this.querySelector('.sticky-atc-bar__form [name="add"]');
        const mainForm = this.mainProductInfo?.querySelector('.product-form');

        const isSoldOutOrUnavailable = !variant || variant.available === false;
        const isWaitlistFromMain = mainSubmitBtn?.getAttribute('data-waitlist-trigger') === 'true';
        const isWaitlistEnabled =
          isWaitlistFromMain ||
          this.getAttribute('data-enable-waitlist') === 'true' ||
          mainForm?.getAttribute('data-enable-waitlist') === 'true' ||
          mainSubmitBtn?.getAttribute('data-waitlist-configured') === 'true' ||
          currentBtn?.getAttribute('data-waitlist-configured') === 'true';

        const isWaitlist = isSoldOutOrUnavailable && isWaitlistEnabled;

        const defaultPopupLink =
          this.getAttribute('data-default-waitlist-popup-link') ||
          mainForm?.getAttribute('data-default-waitlist-popup-link') ||
          mainSubmitBtn?.getAttribute('data-default-waitlist-popup-link') ||
          currentBtn?.getAttribute('data-default-waitlist-popup-link') ||
          '';

        const defaultWaitlistText =
          this.getAttribute('data-default-waitlist-text') ||
          mainForm?.getAttribute('data-default-waitlist-text') ||
          mainSubmitBtn?.getAttribute('data-default-waitlist-text') ||
          mainSubmitBtn?.getAttribute('data-waitlist-text') ||
          (isWaitlistFromMain ? mainSubmitBtn?.querySelector('.btn__text')?.textContent?.trim() : null) ||
          currentBtn?.getAttribute('data-default-waitlist-text') ||
          FoxTheme.variantStrings.joinWaitlist ||
          'JOIN THE WAITLIST';

        const defaultModalId =
          this.getAttribute('data-default-waitlist-modal-id') ||
          mainForm?.getAttribute('data-default-waitlist-modal-id') ||
          mainSubmitBtn?.getAttribute('data-default-modal-id') ||
          currentBtn?.getAttribute('data-default-modal-id') ||
          '';

        const defaultCustomJs =
          this.getAttribute('data-default-waitlist-custom-js') ||
          mainForm?.getAttribute('data-default-waitlist-custom-js') ||
          mainSubmitBtn?.getAttribute('data-default-custom-js') ||
          currentBtn?.getAttribute('data-default-custom-js') ||
          '';

        const waitlistAttributes = isWaitlist
          ? {
              triggerSelector:
                mainSubmitBtn?.getAttribute('data-trigger-selector') ||
                currentBtn?.getAttribute('data-trigger-selector') ||
                defaultPopupLink,
              popupLink:
                mainSubmitBtn?.getAttribute('data-waitlist-popup-link') ||
                currentBtn?.getAttribute('data-waitlist-popup-link') ||
                defaultPopupLink,
              modalId:
                mainSubmitBtn?.getAttribute('data-modal-id') ||
                currentBtn?.getAttribute('data-modal-id') ||
                defaultModalId,
              customJs:
                mainSubmitBtn?.getAttribute('data-custom-js') ||
                currentBtn?.getAttribute('data-custom-js') ||
                defaultCustomJs,
              variantId: variant?.id || '',
              variantTitle: variant?.title || '',
              productId: this.dataset.productId || mainSubmitBtn?.getAttribute('data-product-id') || '',
              productTitle:
                mainSubmitBtn?.getAttribute('data-product-title') ||
                document.querySelector('.product__title')?.textContent?.trim() ||
                '',
              waitlistText: defaultWaitlistText,
            }
          : {};

        if (isWaitlist) {
          this.updateButton(false, defaultWaitlistText, true, true, waitlistAttributes);
          return;
        }

        if (!variant) {
          this.updateButton(true, FoxTheme.variantStrings.unavailable, true, false);
          return;
        }

        if (!variant.available) {
          this.updateButton(true, FoxTheme.variantStrings.soldOut, true, false);
          return;
        }

        this.updateButton(false, FoxTheme.variantStrings.addToCart, true, false);
      }
    }
  );
}
